<div *ngFor="let slide of sortedSlides"
class="svg-editor card-body slide{{ slide.id }}" appAppMutationObserver [innerHtml]="slide.documentElement.outerHTML | safeHTML"></div>
